






























import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator';
import { trackAction, TrackingAction, getSession } from '@/lib/tracking';
import Modal from '../Modal.vue';
import Store from '@/vuex-decorators/state.decorator';

@Component({
  components: {
    Modal
  }
})
export default class RequestMeetingModal extends Vue {
  @Prop() visible!: boolean;
  @Ref() readonly form!: HTMLFormElement;

  @Emit()
  close() {}

  @Store()
  viewingMedicalInformation!: boolean;

  submit(e: Event) {
    e.preventDefault();

    // Only allow valid forms
    if (!this.form.reportValidity()) return;

    // Grab all form values
    const formValues = [];
    for (const element of this.form.elements) {
      const { name, value } = element as any;
      if (name) formValues.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }

    // Combine form values into query string
    const queryString = formValues.join('&');

    // Send request
    const url = `https://sunovionexhibitbooth.com/tracking/reprequest.php?asset=latudabooth&sessionid=${getSession()}&${queryString}`;
    fetch(url);

    // Track send
    trackAction(`Request meeting form submit`, TrackingAction.FORM_SUBMIT);

    // Reset and close
    this.form.reset();
    this.close();
  }

  nonUS(event: MouseEvent) {
    event.preventDefault();
    this.viewingMedicalInformation = true;
    this.close();
  }
}
